import PartMappingSubcontract from '@/models/PartMappingSubcontract/PartMappingSubcontract';

export default class PartMappingSubcontractFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.remarksMultiple = '';
		this.partSubcontId  = '';
		this.partSubcontPartNumber = '';
		this.vendorSubcontractId  = '';
		this.vendorSubcontractCode = '';
		this.name = '';
		this.officeAddress = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			partId : '0',
			partPartNumber : '0',
			remarksMultiple : '0',
			partSubcontId : '0',
			partSubcontPartNumber : '0',
			vendorSubcontractId : '0',
			vendorSubcontractCode : '0',
			name : '0',
			officeAddress : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}